import { RejectTheDocumentQueryType } from '@/common/queries/rejectTheDocument/rejectTheDocumentQuery.type';
import { fetchApi } from '@/config/axiosSetting';

export const rejectTheDocumentQueryFunction = (
  param: RejectTheDocumentQueryType,
): Promise<any> => {
  return fetchApi.post(`/actions/${param?.id}/reject_case/`, {
    data: { description: param?.description },
  });
};
